import React from "react";
import ReportWorkspace from "./ReportWorkspace";

const ReportInvoice = props => <ReportWorkspace type="invoice" history={props.history} />;

export default ReportInvoice;
